import { defineSlotRecipe } from "@chakra-ui/react";
import { breadcrumbAnatomy } from "@chakra-ui/react/anatomy";

const breadcrumbRecipe = defineSlotRecipe({
  slots: breadcrumbAnatomy.keys(),
  base: {
    list: {
      color: "brand.breadcrumbText",
    },
    link: {
      fontSize: "16px",
      fontWeight: 400,
      color: "brand.breadcrumbText",
    },
    separator: {
      marginTop: "-1px",
    },
  },
  variants: {
    size: {
      md: {
        list: {
          fontSize: "md",
          lineHeight: "1.5",
        },
      },
    },
  },
});

export default breadcrumbRecipe;
